import camelCase from 'lodash/camelCase'

// Storing in variable a context with all files in this folder
// ending with `.js`.
const requireModule = require.context('.', false, /\.js$/)

// a hash table of modules to be exported for registration
const modules = {}

requireModule.keys().forEach(fileName => {
    // ignore this file
    if (fileName === './index.js') return

    // filter fullstops and extension
    // and return a camel-case name for the file
    const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''))

    // create a dynamic object with all modules
    modules[moduleName] = {
        namespaced: true,
        ...requireModule(fileName).default
    }
})

// This will automatically inject the default state provided by the backend
// Look at VuexService where the defaults are generated
if (window.__defaultVuexState !== undefined) {
    Object.keys(modules).forEach(moduleName => {
        let newState = Object.assign({}, modules[moduleName].state, window.__defaultVuexState[moduleName]);

        modules[moduleName].state = {...newState};
    })
}

export default modules
